import { render, staticRenderFns } from "./QuoteLogs.vue?vue&type=template&id=6971ed22"
import script from "./QuoteLogs.vue?vue&type=script&lang=js"
export * from "./QuoteLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports